<div class="app-shell">

  <!-- -------------------------------------------------- -->
  <!-- Sidebar Navigation -->
  <!-- -------------------------------------------------- -->
  <aside class="sidebar" [class.sidebar-open]="menuOpen()">

    <div class="sidebar-brand">
      <span class="brand-icon">🧾</span>
      <span class="brand-name">RSG Invoice</span>
    </div>

    <nav class="sidebar-nav">

      <a
        routerLink="/dashboard"
        routerLinkActive="nav-active"
        class="nav-item"
        (click)="closeMenu()"
      >
        <span class="nav-icon">🏠</span>
        <span class="nav-label">Dashboard</span>
      </a>

      <div class="nav-group-label">Stammdaten</div>

      <a
        routerLink="/customers"
        routerLinkActive="nav-active"
        class="nav-item"
        (click)="closeMenu()"
      >
        <span class="nav-icon">👥</span>
        <span class="nav-label">Kunden</span>
      </a>

      <a
        routerLink="/articles"
        routerLinkActive="nav-active"
        class="nav-item"
        (click)="closeMenu()"
      >
        <span class="nav-icon">📦</span>
        <span class="nav-label">Artikel</span>
      </a>

      <a
        routerLink="/article-categories"
        routerLinkActive="nav-active"
        class="nav-item"
        (click)="closeMenu()"
      >
        <span class="nav-icon">🏷️</span>
        <span class="nav-label">Kategorien</span>
      </a>

      <a
        routerLink="/units"
        routerLinkActive="nav-active"
        class="nav-item"
        (click)="closeMenu()"
      >
        <span class="nav-icon">📏</span>
        <span class="nav-label">Einheiten</span>
      </a>

      <div class="nav-group-label">Abrechnung</div>

      <a
        routerLink="/quotes"
        routerLinkActive="nav-active"
        class="nav-item"
        (click)="closeMenu()"
      >
        <span class="nav-icon">📋</span>
        <span class="nav-label">Angebote</span>
      </a>

      <a
        routerLink="/invoices"
        routerLinkActive="nav-active"
        class="nav-item"
        (click)="closeMenu()"
      >
        <span class="nav-icon">📄</span>
        <span class="nav-label">Rechnungen</span>
      </a>

    </nav>

    <div class="sidebar-footer">
      <span class="version-label">v0.1.0</span>
    </div>

  </aside>

  <!-- -------------------------------------------------- -->
  <!-- Hauptbereich -->
  <!-- -------------------------------------------------- -->
  <div class="main-wrapper">

    <!-- Topbar (mobile + Breadcrumb-Zeile) -->
    <header class="topbar">
      <button
        type="button"
        class="menu-toggle"
        (click)="toggleMenu()"
        aria-label="Menü öffnen"
      >☰</button>
      <span class="topbar-title">{{ title() }}</span>
    </header>

    <!-- Overlay für mobile Sidebar -->
    @if (menuOpen()) {
      <div class="sidebar-overlay" (click)="closeMenu()"></div>
    }

    <!-- Router Content -->
    <main class="main-content">
      <router-outlet />
    </main>

  </div>

</div>
